<script>
import useClipboard from "vue-clipboard3";

import { ElMessage } from "element-plus";
import i18n from "@/lang";
const { t } = i18n.global;
export default {
  name: "CopyText",
  components: {},
  props: {
    label: String,
    value: [String, Number],
  },
  setup(props) {
    const onCopy = async (e) => {
      e.stopPropagation();
      const { toClipboard } = useClipboard();
      try {
        await toClipboard(props.value + "");
        ElMessage.success(t("orderList.message2"));
      } catch (e) {
        ElMessage.error(t("orderList.message3"));
      }
    };
    return () => {
      if (!props.value && !props.label) {
        return "-";
      }
      if (props.label && !props.value) {
        return <div>{props.label}：-</div>;
      }
      return (
        <div class="copy-text">
          <div class={"copy-text-content"}>
            <div class={"copy-text-content__text"}>
              {props.label ? `${props.label}：` : ""}
              <span title={props.value}>{props.value}</span>
            </div>
            <div class="copy-icon" onClick={onCopy} style="margin-left: 5px;">
              <el-icon lass="copy-text-content__icon">
                <CopyDocument />
              </el-icon>
            </div>
          </div>
        </div>
      );
    };
  },
};
</script>
<style lang="scss" scoped>
.copy-text {
  width: 100%;
  &-content {
    display: flex;
    align-items: center;
    &__text {
      flex: 0 1 auto;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-right: 5px;
    }
    &__icon {
      flex: 0 0 auto;
      cursor: pointer;
    }
  }
  .copy-icon {
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>
